// extracted by mini-css-extract-plugin
export default {"poemcontainer":"poemcontainer__gSEPI"};